import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { useLocation } from 'react-router-dom';
import store from 'controller/redux/store';
import Routes from 'controller/routes';
import HeaderComponent from 'render/views/components/HeaderComponent';
import FooterComponent from 'render/views/components/FooterComponent';
import { PATHS } from 'controller/constants';
import TokenExpiryWrapper from 'controller/hooks/TokenExpiryWrapper';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {

  const HIDE_MENU_THRESHOLD = 1650;

  const location = useLocation();
  const [locationReady, setLocationReady] = useState(false);
  const [showContent, setShowContent] = useState(true); // Move this above the early return

  const toggleContentVisibility = () => {
    if (window.innerWidth < HIDE_MENU_THRESHOLD) {
      setShowContent((prev) => !prev);
    }
  };

  useEffect(() => {
    setLocationReady(true);
  }, [location]);

  if (!locationReady) {
    console.log('Location not ready, skipping all rendering');
    return null; // Safely return without violating hooks rules
  }

  const isMinimalLayoutRoute =
    location.pathname === PATHS.LOGIN ||
    location.pathname.startsWith(PATHS.RESET_PASSWORD) ||
    location.pathname.startsWith(PATHS.CONFIRM_PARTNER);

  console.log(isMinimalLayoutRoute ? 'Rendering minimal layout' : 'Rendering full layout');

  return isMinimalLayoutRoute ? (
    <Provider store={store}>
      <TokenExpiryWrapper>
        <Routes />
        <ToastContainer />
      </TokenExpiryWrapper>
    </Provider>
  ) : (
    <Provider store={store}>
      <TokenExpiryWrapper>
        <div id="responsive-warning">
          <p>Esta plataforma não foi preparada para resoluções pequenas. Por favor expanda a janela.</p>
        </div>
        <div className={showContent ? 'show-menu' : 'hide-menu'}>
          <HeaderComponent
            toggleContentVisibility={toggleContentVisibility}
            showContent={showContent}
            setShowContent={setShowContent}
          />
          <Routes />
          <FooterComponent />
        </div>
        <ToastContainer />
      </TokenExpiryWrapper>
    </Provider>
  );
};

export default App;
